import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ApiServiceService } from "../../api-service.service";

@Component({
  selector: "ngx-forgotpassword",
  templateUrl: "./forgotpassword.component.html",
  styleUrls: ["./forgotpassword.component.scss"],
})
export class ForgotpasswordComponent {
  username: string = "";
  email: string = "";
  errorMessage: string = "";

  constructor(private apiService: ApiServiceService, private router: Router) {}

  // submitForm() {
  //   if (!this.username && !this.email) {
  //     this.errorMessage = "Please enter your username or email.";
  //     return;
  //   }

  //   const formdata = {
  //     UserName: this.username,
  //     Email: this.email,
  //   };

  //   this.apiService.adminForgotPassword(formdata).subscribe(
  //     (response: any) => {
  //       console.log("Response from backend:", response.message);

  //       // console.log("Response from backend:", response);
  //       const email = response.Email || formdata.Email;
  //       console.log("Email:", email);
  //       if (response.UserID != 0) {
  //         this.router.navigate([
  //           "/auth/resetpassword",
  //           { UserID: response.UserID },
  //         ]);
  //       }
  //     },
  //     (error: any) => {
  //       console.error("Error:", error);
  //       this.errorMessage =
  //         "Failed to process your request. Please try again later.";
  //     }
  //   );
  // }

  submitForm() {
    if (!this.username && !this.email) {
      this.errorMessage = "Please enter your username or email.";
      return;
    }

    const formdata = {
      UserName: this.username,
      Email: this.email,
    };

    this.apiService.adminForgotPassword(formdata).subscribe(
      (response: any) => {
        console.log("Response from backend:", response.message);

        if (response.UserID && response.UserID != 0) {
          this.router.navigate([
            "/auth/resetpassword",
            { UserID: response.UserID },
          ]);
        } else {
          this.errorMessage =
            response.message || "Invalid username or email. Please try again.";
        }
      },
      (error: any) => {
        console.error("Error:", error);
        if (error.status === 400) {
          this.errorMessage = error.error.message;
        } else {
          this.errorMessage =
            "Failed to process your request. Please try again later.";
        }
      }
    );
  }

  cancel() {
    this.router.navigate(["/auth"]);
    this.username = "";
    this.email = "";
    this.errorMessage = "";
  }

  ngOnInit(): void {
    const el = document.getElementById("nb-global-spinner");
    if (el) {
      el.style["display"] = "none";
    }
  }
}
